import React from "react";

const RatingFilter = (props) => {
    const { title = "Patient Rating", value, onChange } = props;

    console.log("🔍 RatingFilter props:", { value, onChange });

    const ratings = [4, 3, 2, 1];

    const handleChange = (rating) => {
        if (typeof onChange === "function") {
            onChange(value === rating ? null : rating);
        } else {
            console.warn("⚠️ onChange is not a function:", onChange);
        }
    };

    return (
        <div className="mb-3">
            <p className="fs-6 mb-1">{title}</p>
            {ratings.map((rating) => (
                <div key={rating} className="mb-2">
                    <input
                        type="checkbox"
                        className="btn-check"
                        name="rating"
                        id={`rating-${rating}`}
                        checked={value === rating}
                        onChange={() => handleChange(rating)}
                        autoComplete="off"
                    />
                    <label
                        className="btn btn-outline-light border border-1 text-dark d-inline-flex align-items-center gap-2"
                        htmlFor={`rating-${rating}`}
                    >
                        {[...Array(rating)].map((_, i) => (
                            <i key={i} className="bi bi-star-fill text-danger" />
                        ))}
                        <span className="fst-normal small">& Up</span>
                    </label>
                </div>
            ))}
        </div>
    );
};

export default RatingFilter;
